import { RemoveRedEye } from '@material-ui/icons';
import { Button, Pagination, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'react-recompose';
import moment from 'moment-timezone';
import AuditLogsModal from './AuditLogsModal';

const ENTITY_NAME_MAP = {
  user: 'user',
  restaurant: 'restaurant',
  order: 'order',
  deals: 'deals',
};

function AuditLogsTable({ intl, auditLogsData, total, onChangePage }) {
  const [isShowDetailModal, setShowDetailModal] = useState(false);
  const [auditLogsInfo, setAuditLogsInfo] = useState(null);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleChangePage = (page, size) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage((page - 1) * size, size);
  };

  const handleShowSizeChange = (c, s) => {
    onChangePage(c, s);
  };

  const capitalizeFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <div className="auditLogs_table_layout">
      <div className="table_content">
        <div className="table_header">
          <div className="entity">
            <FormattedMessage id="Entity" />
          </div>
          <div className="entityId">
            <FormattedMessage id="Entity ID" />
          </div>
          <div className="entityName">
            <FormattedMessage id="Description" />
          </div>
          <div className="action">
            <FormattedMessage id="Action" />
          </div>
          <div className="actorId">
            <FormattedMessage id="Actor ID" />
          </div>
          <div className="username">
            <FormattedMessage id="Username" />
          </div>
          <div className="created_at">
            <FormattedMessage id="Created at" />
          </div>
          <div className="actions">
            <FormattedMessage id="Actions" />
          </div>
        </div>
        {auditLogsData &&
          auditLogsData.map((item, index) => (
            <div className={`table_item action_states_${item.action}`} key={index}>
              <div className="entity">
                <p>{capitalizeFirst(item.entityType)}</p>
              </div>
              <div className="entityId">
                <p>{item.entityId}</p>
              </div>
              <div className="entityName">
                <p>
                  {item.entityType === ENTITY_NAME_MAP[item.entityType]
                    ? item?.changes?.after?.description || item?.changes?.before?.description || '-'
                    : '-'}
                </p>
              </div>
              <div className="action">
                <p>{item.action ? intl.formatMessage({ id: item.action }) : '-'}</p>
              </div>
              <div className="actorId">
                <p>{item.actorId}</p>
              </div>
              <div className="username">
                <p>
                  {/* {item.username} */}
                  {item?.actorMetadata?.name || '-'}
                </p>
              </div>
              <div className="created_at">
                <p>{`${moment(item.createdAt).tz('America/Guatemala').format('LL')}`}</p>
              </div>
              <div className="actions">
                <Tooltip placement="top" title={intl.formatMessage({ id: 'Show details' })}>
                  <Button
                    className="detail_btn"
                    onClick={() => {
                      setAuditLogsInfo(item);
                      setShowDetailModal(true);
                    }}
                  >
                    <RemoveRedEye />
                  </Button>
                </Tooltip>
              </div>
            </div>
          ))}
      </div>
      <div className="pagination_wrapper">
        <Pagination
          showSizeChanger
          defaultCurrent={1}
          defaultPageSize={10}
          current={current}
          pageSize={pageSize}
          pageSizeOptions={['5', '10', '20', '30']}
          total={total}
          onChange={handleChangePage}
          onShowSizeChange={handleShowSizeChange}
        />
        <div className="total">
          {intl.formatMessage({ id: 'results' })}: {total}
        </div>
      </div>
      <AuditLogsModal isOpenModal={isShowDetailModal} onCloseModal={handleCloseModal} auditLogsInfo={auditLogsInfo} />
    </div>
  );
}

AuditLogsTable.defaultProps = {
  auditLogsData: [],
  total: '0',
};

export default compose(injectIntl)(AuditLogsTable);
